import { defineStore, acceptHMRUpdate } from 'pinia';
import { GetUserResponse } from '@daocloud-proto/ghippo/v1alpha1/currentuser.pb';

const useUserStore = defineStore('user', {
  state: () => ({ user: {} as GetUserResponse }),
  getters: {
    showSubAccount: (state) => state.user.canTransferToMain || state.user.isMainAccount,
  },
});

// this is for webpack 5.x
if (import.meta.webpackHot) {
  import.meta.webpackHot?.accept(acceptHMRUpdate(useUserStore, import.meta.webpackHot));
}

export default useUserStore;
